/** Annuaire workforce (TAWA) — source des membres/assignés (pas de backend
 * users côté Todo, DT : réutilisation des Modules livrés). */
import { tawaRequest } from "./client";
import type { TawaRole } from "../lib/auth/useRole";

export interface AdminUser {
  id: string;
  username: string;
  worker_url: string;
  email: string;
  first_name?: string | null;
  last_name?: string | null;
  enabled: boolean;
  tawa_role?: TawaRole | null;
}

export interface AdminUsersResponse {
  users: AdminUser[];
}

export function listUsers(): Promise<AdminUsersResponse> {
  return tawaRequest({ method: "GET", url: "/admin/users" });
}

/** Annuaire léger — même DTO que listUsers, ouvert à tout membre authentifié
 * du tenant (route TAWA /directory, pas /admin/users). À utiliser pour la
 * résolution de noms (assignés, commentaires, équipe) hors écrans admin. */
export function listDirectory(): Promise<AdminUsersResponse> {
  return tawaRequest({ method: "GET", url: "/directory" });
}

export function displayName(u: AdminUser): string {
  const full = [u.first_name, u.last_name].filter(Boolean).join(" ").trim();
  return full || u.username || u.email;
}
